import { IUserRole } from '@halo/interfaces/user-role'
import { UserTypeId } from '@halo/enums/user-type'

/**
 * Both internal user types, not just INTERNAL. INTERNAL_API carries staff reach the same way a
 * person does, and the database constraint on has_network_scope admits exactly these two, so a
 * check that omits INTERNAL_API would hide the control on roles allowed to hold the grant.
 */
const INTERNAL_USER_TYPE_IDS: number[] = [UserTypeId.INTERNAL, UserTypeId.INTERNAL_API]

export const isInternalRole = (userRole: Pick<IUserRole, 'user_type_id'>): boolean =>
    INTERNAL_USER_TYPE_IDS.includes(userRole.user_type_id)
